import { Controller } from "@hotwired/stimulus"
import {
  createHereMap,
  disposeHereMap,
  circleIcon,
  polyline,
  singleBubble,
  fitToObjects,
} from "../helpers/here_map_helpers"

// Standort-Tab: renders one employee's GPS trail for a day as a polyline, with a marker
// per derived site visit. One-shot render from the track/sites values — the data is a
// finished day, so no live updates.
const GERMANY_CENTER = { lat: 51.1657, lng: 10.4515 }
const TRACK_COLOR = "#009C72"
const SITE_COLOR = "#2563eb"

export default class extends Controller {
  static targets = ["map"]
  static values = { track: Array, sites: Array }

  connect() {
    createHereMap(this.mapTarget, { center: this.computeCenter(), zoom: 13 })
      .then(({ H, map, ui }) => this.render(H, map, ui))
      .catch((error) => console.error("HERE map failed to load", error))
  }

  disconnect() {
    disposeHereMap(this.map)
    this.map = null
  }

  render(H, map, ui) {
    this.map = map
    this.showBubble = singleBubble(H, ui)
    const objects = []

    if (this.trackValue.length > 1) {
      const line = polyline(H, this.trackValue, { color: TRACK_COLOR })
      map.addObject(line)
      objects.push(line)
    }

    this.sitesValue.forEach((site) => {
      const position = { lat: parseFloat(site.lat), lng: parseFloat(site.lng) }
      const marker = new H.map.Marker(position, { icon: circleIcon(SITE_COLOR) })
      marker.addEventListener("tap", () => this.showBubble(position, this.bubbleContent(site)))
      map.addObject(marker)
      objects.push(marker)
    })

    if (objects.length > 1) fitToObjects(H, map, objects)
  }

  bubbleContent(site) {
    return `
      <div class="w-48 flex flex-col text-sm">
        <h3 class="font-semibold">${this.escapeHtml(site.name)}</h3>
        <p class="text-gray-500">${this.escapeHtml(site.arrived)} – ${this.escapeHtml(site.departed)}</p>
      </div>
    `
  }

  escapeHtml(value) {
    if (value == null) return ""
    const el = document.createElement("div")
    el.textContent = String(value)
    return el.innerHTML
  }

  computeCenter() {
    const points = this.trackValue.length ? this.trackValue : this.sitesValue
    if (!points.length) return GERMANY_CENTER
    const lats = points.map((p) => parseFloat(p.lat))
    const lngs = points.map((p) => parseFloat(p.lng))
    return {
      lat: (Math.min(...lats) + Math.max(...lats)) / 2,
      lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
    }
  }
}
